{
  "name": "appshell",
  "version": "71.0.0",
  "license": "UNLICENSED",
  "repository": {
    "type": "git",
    "url": "git@ssh.dev.azure.com:v3/MiXTelematics/UnityFC/appshell.ui"
  },
  "scripts": {
    "ng": "ng",
    "kendo-license-activate": "kendo-ui-license activate",
    "serve": "node metadata.js && npm run build-workers && node --max-old-space-size=7168 node_modules/@angular/cli/bin/ng serve appshell",
    "build": "node metadata.js && npm run build-workers && node --max-old-space-size=6272 node_modules/@angular/cli/bin/ng build",
    "build-local-pwa": "npm run build-workers && npm run build -- --configuration=docker",
    "build-workers": "npx tsc -p tsconfig.worker.json",
    "watch-workers": "npx tsc -w -p tsconfig.worker.json",
    "test:ci": "node --max-old-space-size=6272 node_modules/@angular/cli/bin/ng test --browsers=headless --watch=false --code-coverage",
    "lint": "ng lint",
    "lint-report": "ng lint --format checkstyle --output-file lint-output/checkstyle.xml",
    "circular-dependency-scan": "madge src/app --circular",
    "orphan-scan": "madge src/app --orphans"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "22.1.8",
    "@angular/cdk": "22.1.8",
    "@angular/common": "22.1.8",
    "@angular/core": "22.1.8",
    "@angular/forms": "22.1.8",
    "@angular/localize": "22.1.8",
    "@angular/platform-browser": "22.1.8",
    "@angular/platform-browser-dynamic": "22.1.8",
    "@angular/router": "22.1.8",
    "@angular/service-worker": "22.1.8",
    "@fc/shared": "^31.0.2",
    "@googlemaps/markerclusterer": "2.6.2",
    "@grafana/faro-instrumentation-fetch": "1.19.0",
    "@grafana/faro-instrumentation-xhr": "1.19.0",
    "@grafana/faro-web-sdk": "1.19.0",
    "@grafana/faro-web-tracing": "1.19.0",
    "@jsonforms/core": "3.3.0",
    "@jsverse/transloco": "8.2.0",
    "@jsverse/transloco-locale": "8.2.0",
    "@jsverse/transloco-messageformat": "8.2.0",
    "@ngneat/bind-query-params": "6.0.0",
    "@ngneat/elf": "2.5.1",
    "@ngneat/elf-cli-ng": "1.0.0",
    "@ngneat/elf-devtools": "1.3.0",
    "@ngneat/elf-entities": "5.0.2",
    "@ngneat/elf-pagination": "1.1.0",
    "@ngneat/elf-persist-state": "1.2.1",
    "@ngneat/elf-requests": "1.9.2",
    "@ngneat/elf-state-history": "1.4.0",
    "@progress/kendo-angular-buttons": "25.2.0",
    "@progress/kendo-angular-charts": "25.2.0",
    "@progress/kendo-angular-common": "25.2.0",
    "@progress/kendo-angular-conversational-ui": "25.2.0",
    "@progress/kendo-angular-dateinputs": "25.2.0",
    "@progress/kendo-angular-dialog": "25.2.0",
    "@progress/kendo-angular-dropdowns": "25.2.0",
    "@progress/kendo-angular-excel-export": "25.2.0",
    "@progress/kendo-angular-gauges": "25.2.0",
    "@progress/kendo-angular-grid": "25.2.0",
    "@progress/kendo-angular-icons": "25.2.0",
    "@progress/kendo-angular-indicators": "25.2.0",
    "@progress/kendo-angular-inputs": "25.2.0",
    "@progress/kendo-angular-intl": "25.2.0",
    "@progress/kendo-angular-l10n": "25.2.0",
    "@progress/kendo-angular-label": "25.2.0",
    "@progress/kendo-angular-layout": "25.2.0",
    "@progress/kendo-angular-listview": "25.2.0",
    "@progress/kendo-angular-menu": "25.2.0",
    "@progress/kendo-angular-navigation": "25.2.0",
    "@progress/kendo-angular-notification": "25.2.0",
    "@progress/kendo-angular-pager": "25.2.0",
    "@progress/kendo-angular-pdf-export": "25.2.0",
    "@progress/kendo-angular-popup": "25.2.0",
    "@progress/kendo-angular-progressbar": "25.2.0",
    "@progress/kendo-angular-scheduler": "25.2.0",
    "@progress/kendo-angular-scrollview": "25.2.0",
    "@progress/kendo-angular-toolbar": "25.2.0",
    "@progress/kendo-angular-tooltip": "25.2.0",
    "@progress/kendo-angular-treeview": "25.2.0",
    "@progress/kendo-angular-upload": "25.2.0",
    "@progress/kendo-angular-utils": "25.2.0",
    "@progress/kendo-data-query": "1.7.3",
    "@progress/kendo-date-math": "1.5.17",
    "@progress/kendo-drawing": "1.25.6",
    "@progress/kendo-svg-icons": "5.5.0",
    "@svgdotjs/svg.js": "3.2.5",
    "ajv": "8.17.1",
    "ajv-formats": "3.0.1",
    "core-js": "3.37.1",
    "crypto": "1.0.1",
    "date-fns": "4.1.0",
    "date-fns-tz": "3.2.0",
    "elf-sync-state": "1.3.0",
    "es-module-shims": "2.8.4",
    "json-logic-js": "2.0.5",
    "jsonref": "9.0.2",
    "keycloak-js": "26.2.1",
    "lodash-es": "4.17.21",
    "marked": "17.0.1",
    "messageformat": "4.0.0",
    "path-browserify": "1.0.1",
    "post-robot": "^8.0.32",
    "querystring-es3": "0.2.1",
    "rxjs": "7.8.2",
    "socket.io-client": "4.8.1",
    "tslib": "2.4.1",
    "vanilla-jsoneditor": "0.23.8",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@angular-architects/native-federation": "22.1.3",
    "@angular-devkit/architect": "0.2201.9",
    "@angular-eslint/builder": "22.5.0",
    "@angular-eslint/eslint-plugin": "22.5.0",
    "@angular-eslint/eslint-plugin-template": "22.5.0",
    "@angular-eslint/schematics": "22.5.0",
    "@angular-eslint/template-parser": "22.5.0",
    "@angular/build": "22.1.9",
    "@angular/cli": "22.1.9",
    "@angular/compiler": "22.1.8",
    "@angular/compiler-cli": "22.1.8",
    "@angular/language-service": "22.1.8",
    "@eslint/js": "9.39.1",
    "@progress/kendo-licensing": "1.11.3",
    "@progress/kendo-theme-core": "14.6.0",
    "@progress/kendo-theme-default": "14.6.0",
    "@progress/kendo-theme-utils": "14.6.0",
    "@types/google.maps": "3.58.1",
    "@types/jasmine": "5.1.13",
    "@types/lodash-es": "4.17.12",
    "@types/node": "20.19.4",
    "@types/post-robot": "^10.0.6",
    "@types/supercluster": "7.1.3",
    "@typescript-eslint/eslint-plugin": "8.71.0",
    "@typescript-eslint/parser": "8.71.0",
    "angular-eslint": "22.5.0",
    "eslint": "9.39.1",
    "eslint-formatter-checkstyle": "^9.0.1",
    "eslint-output": "4.0.2",
    "eslint-plugin-ban": "2.0.0",
    "eslint-plugin-import": "2.32.0",
    "eslint-plugin-jsdoc": "61.4.1",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "5.13.0",
    "jasmine-spec-reporter": "7.0.0",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "2.2.1",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.1.0",
    "karma-junit-reporter": "2.0.1",
    "karma-mocha-reporter": "2.2.5",
    "karma-sonarqube-reporter": "1.4.0",
    "madge": "8.0.0",
    "pre-commit": "1.2.2",
    "puppeteer": "24.31.0",
    "typescript": "6.0.3",
    "typescript-eslint": "8.71.0"
  },
  "overrides": {
    "minimatch": "3.1.2",
    "eslint": "9.39.1",
    "madge": {
      "typescript": "6.0.3"
    }
  },
  "browserslist": [
    "last 1 Chrome major version",
    "last 1 Safari major version",
    "last 1 Firefox major version",
    "last 1 Edge major version"
  ],
  "browser": {
    "querystring": "querystring-es3",
    "path": "path-browserify"
  },
  "elf": {
    "cli": {
      "repoTemplate": "class",
      "idKey": "id",
      "repoLibrary": "./src/app/store/",
      "plugins": [
        "@ngneat/elf-cli-ng"
      ]
    }
  }
}
